import React from "react";

export default function WhatsAppButton() {
  const number = "919999999999";
  const text = encodeURIComponent("Hello Dabkazari — I'd like to know more.");
  return (
    <a
      href={`https://wa.me/${number}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed z-40 bottom-6 right-6 w-14 h-14 rounded-full flex items-center justify-center bg-[#5C1A1B] hover:bg-[#701C1D] text-[#FDFBF7] shadow-lg transition-colors"
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <svg width="26" height="26" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.63 3.41 4.535 4.588.615.387 2.53 1.404 3.216 1.404.688 0 1.318-.66 1.318-1.318 0-.315-.215-.53-.372-.716a.94.94 0 0 0-.63-.315zM16 4C9.372 4 4 9.372 4 16c0 2.02.5 4.02 1.46 5.79L4 28l6.44-1.427A11.94 11.94 0 0 0 16 28c6.628 0 12-5.372 12-12S22.628 4 16 4zm0 22c-1.86 0-3.69-.478-5.293-1.386l-.377-.222-3.807.844.856-3.712-.243-.386A9.94 9.94 0 0 1 6 16C6 10.486 10.486 6 16 6s10 4.486 10 10-4.486 10-10 10z"/>
      </svg>
    </a>
  );
}
